// components/CopySignalLink.js
"use client";

import React, { useEffect, useState } from "react";

export default function CopySignalLink() {
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (!copied) return;
    const t = setTimeout(() => setCopied(false), 1400);
    return () => clearTimeout(t);
  }, [copied]);

  const handleClick = () => {
    try {
      if (typeof window !== "undefined" && navigator?.clipboard?.writeText) {
        navigator.clipboard
          .writeText(window.location.href)
          .then(() => setCopied(true))
          .catch(() => {});
      }
    } catch {
      // Silently ignore copy errors
    }
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      className="inline-flex items-center justify-center gap-2 rounded-full px-4 py-2 text-sm font-semibold border border-slate-700 bg-slate-900/40 text-slate-100 hover:bg-slate-900/65 focus:outline-none focus-visible:ring-2 focus-visible:ring-teal-300 focus-visible:ring-offset-2 focus-visible:ring-offset-slate-950 transition"
      aria-label="Copy link to this Signal"
    >
      {copied ? "Copied" : "Copy link"}
      <span aria-hidden="true" className="text-slate-400">
        ↗
      </span>
    </button>
  );
}
